/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useMemo } from 'react';
import { Grid, Typography } from '@mui/material';
import ReadMoreLess from '../../../Reusable/ReadMoreLess/Readmoreless';
import SamplePoll from '../../../Reusable/SamplePoll';
import FeedMediaView from '../FeedMediaView';
import RepostCard from '../Components/RepostCard';
import OccasionCardView from '../../../Reusable/OccasionCard';
import { LanguageContext } from '../../../../../../libs/Context';
import FeedDocView from './FeedDocView';

const FeedBody = (props) =>
{
	const { feed, handleUpdateFeed, noAction, type, selectedActivity, hideMedia = false, from } = props;
	const { language } = useContext(LanguageContext);

	if (feed?.feedModified)
	{
		return (
			<Grid item container xs={12}>
				<Typography pt='var(--pixel8)' color={'gray'}>
					{language.modifiedText}
				</Typography>
			</Grid>
		);
	}
	const mediaList = hideMedia || feed?.feedType === 'occasion'
		? []
		: useMemo(
			() => feed?.media?.filter((mediaItem) => mediaItem?.type !== 'link' && !mediaItem?.type?.match('application')),
			[ feed?.media ]
		);
	const linkList = useMemo(
		() => feed?.media?.filter((mediaItem) => mediaItem?.type === 'link'),
		[ feed?.media ]
	);
	const docList = useMemo(
		() => feed?.media?.filter((mediaItem) => mediaItem?.type?.match('application')),
		[ feed?.media ]
	);

	return (
		<Grid item container xs={12} style={{ wordBreak: 'break-all' }}>
			{/* Render description */}
			<Grid container item>
				<Grid item xs={12} pt={feed?.description ? 'var(--pixel8)' : ''}>
					<ReadMoreLess
						feedId={feed?._id}
						text={feed?.description || ''}
						maxChars={200}
						fontSize='var(--pixel16)'
						fontWeight={400}
						textColor='#5D5D5D'
						buttonColor='var(--primaryColor)'
						showSpeaker={from !== 'repost'}
					/>
				</Grid>
			</Grid>

			{linkList?.length > 0 &&
			linkList.map((link, ind) =>
				(
					<Grid item xs={12} key={ind}>
						<a href={link?.url} target='_blank' rel='noreferrer' style={{ color: 'blue', lineBreak: 'anywhere' }}>{link?.url}</a>
					</Grid>
				))}
			{/* rendering all media items */}
			{docList?.length > 0 && <FeedDocView docList={docList}/>}

			{mediaList?.length > 0 && (
				<Grid item xs={12} mb={1}>
					<FeedMediaView mediaData={mediaList} limit={5} feed={feed} handleUpdateFeed={handleUpdateFeed} from={from} />
				</Grid>
			)}
			{/* Render events data */}
			{feed?.feedType === 'occasion' &&
			<Grid item xs={12} py='var(--pixel8)' >
				<OccasionCardView viewData={feed ?? {}} selectEvent={'occasion'} requestT={'viewEvent'}/>
			</Grid>
			}

			{/* Render poll data */}
			{feed?.feedType === 'poll' &&
			<Grid item xs={12} my='var(--pixel8)'>
				<SamplePoll
					pollCard={{
						...feed?.pollData,
						id            : feed?._id,
						pollsubmitted : feed?.pollsubmitted,
						createdAt     : feed?.createdAt
					}}
					bordercolor={feed?.pollsubmitted ? 'rgba(36, 164, 196, 0.3)' : '#24A4C44D'}
					Cursor={feed?.pollsubmitted ? 'none' : 'pointer'}
					from='list'
					handleUpdateFeed={handleUpdateFeed}
					feed={feed}
					type={type}
					noAction={noAction}
					selectedActivity={selectedActivity}
				/>
			</Grid>
			}

			{feed?.type === 'youtube' &&
			<Grid item mt={1} xs={12}>
				<Typography
					component='a'
					href='youtube_link'
					target='_blank'
					sx={{
						fontSize   : 'var(--pixel16)',
						color      : 'var(--primaryColor)',
						fontWeight : 400,
						cursor     : 'pointer'
					}}
				>
					<Typography sx={{
						textOverflow   : 'ellipsis',
						maxWidth       : '250px',
						whiteSpace     : 'nowrap',
						overflow       : 'hidden',
						textDecoration : 'none',
						'&:hover'      : {
							textDecoration : 'underline'
						}
					}}
					>
						{'https://localhost:3000/news'}
					</Typography>
				</Typography>
			</Grid>
			}
			{feed?.repostObj?.feedId &&
			<Grid item my='var(--pixel8)' xs={12}>
				<RepostCard parentData={feed?.repostObj} />
			</Grid>
			}
		</Grid>
	);
};

export default FeedBody;